var _circle, _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 80,
    viewBox: "0 0 63 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.4987,
    cy: 31.0729,
    r: 31.0729,
    fill: "#E6E6E6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.85,
    y: 31.03,
    width: 29.2902,
    height: 41.4587,
    rx: 7,
    transform: "rotate(2.5 19.85 31.03)",
    fill: "#CCCCCC",
    stroke: "#999999",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.588966,
    y: 27.4057,
    width: 33.2902,
    height: 45.4587,
    rx: 9,
    transform: "rotate(-7.5 0.588966 27.4057)",
    fill: "#F2F2F2",
    stroke: "#999999",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75515 36.1982C2.17845 31.8177 5.26202 27.7991 9.6425 27.2224L24.8019 25.2266C29.1824 24.6499 33.201 27.7335 33.7777 32.114L34.0381 34.0924L3.01561 38.1766L2.75515 36.1982Z",
    fill: "#CCCCCC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.4805,
    y: 25.4863,
    width: 1.30376,
    height: 4.34587,
    rx: 0.65188,
    transform: "rotate(82.5 39.4805 25.4863)",
    fill: "#999999"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5742,
    y: 18.2871,
    width: 1.30376,
    height: 4.34587,
    rx: 0.65188,
    transform: "rotate(-7.5 27.5742 18.2871)",
    fill: "#999999"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2109,
    y: 19.4727,
    width: 1.30376,
    height: 4.34587,
    rx: 0.65188,
    transform: "rotate(37.5 35.2109 19.4727)",
    fill: "#999999"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.25781,
    y: 39.5029,
    width: 25.206,
    height: 1.73835,
    rx: 0.869173,
    transform: "rotate(-7.5 6.25781 39.5029)",
    fill: "#B3B3B3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 7.39062,
    y: 48.1201,
    width: 25.206,
    height: 1.73835,
    rx: 0.869173,
    transform: "rotate(-7.5 7.39062 48.1201)",
    fill: "#B3B3B3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8.52734,
    y: 56.7383,
    width: 25.206,
    height: 1.73835,
    rx: 0.869173,
    transform: "rotate(-7.5 8.52734 56.7383)",
    fill: "#B3B3B3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 6.71094,
    y: 42.9502,
    width: 9.12632,
    height: 1.73835,
    rx: 0.869173,
    transform: "rotate(-7.5 6.71094 42.9502)",
    fill: "#CCCCCC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 7.84766,
    y: 51.5674,
    width: 9.12632,
    height: 1.73835,
    rx: 0.869173,
    transform: "rotate(-7.5 7.84766 51.5674)",
    fill: "#CCCCCC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 8.98047,
    y: 60.1846,
    width: 9.12632,
    height: 1.73835,
    rx: 0.869173,
    transform: "rotate(-7.5 8.98047 60.1846)",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyHistory);
export default __webpack_public_path__ + "static/media/empty_history.b7adf5f15970614e59abc3a7b85ab4ca.svg";
export { ForwardRef as ReactComponent };